import { render } from "./Waypoint.vue?vue&type=template&id=7811939f&scoped=true&ts=true"
import script from "./Waypoint.vue?vue&type=script&lang=ts"
export * from "./Waypoint.vue?vue&type=script&lang=ts"

import "./Waypoint.vue?vue&type=style&index=0&id=7811939f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7811939f"]])

export default __exports__